<template>
  <div class="quizset-button-new" @click="newQuizset">
    新しいクイズセットの作成
  </div>
</template>

<script>
export default {
  methods: {
    newQuizset: function () {
      this.$router.push('/quizset/new')
    }
  }
}
</script>

<style lang="scss" scoped>
.quizset-button-new {
  @include button-ol-primary;
}
</style>
